/* FAYQ theme — interactions (menu, panier AJAX, fiche produit, animations de la maquette). */
(function () {
  var $ = function (id) { return document.getElementById(id); };
  var q = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var cfg = window.FAYQ || {};
  var toastTimer;
  var I = cfg.i18n || {};
  var tr = function (k, v) { var s = I[k] || k; for (var x in (v || {})) s = s.split('{' + x + '}').join(v[x]); return s; };

  /* ---------- Argent ---------- */
  function formatMoney(cents) {
    var c = Math.round(cents), u = Math.floor(c / 100), d = c % 100;
    var en = cfg.locale === 'en', us = String(u).replace(/\B(?=(\d{3})+(?!\d))/g, en ? ',' : ' ');
    return us + (en ? '.' : ',') + (d < 10 ? '0' : '') + d + (en ? ' MAD' : ' DH');
  }

  /* ---------- Toast + compteur ---------- */
  function toast(msg, isError) {
    var t = $('toast'); if (!t) return;
    $('toastMsg').textContent = msg;
    t.classList.toggle('err', !!isError);
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 3600);
  }
  function setCount(n) {
    var c = $('cartCount'); if (!c) return;
    c.textContent = n; c.setAttribute('data-count', n);
  }
  function refreshCount() {
    return fetch(cfg.routes.cart, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); });
  }
  function addItems(items, btn, label) {
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    return fetch(cfg.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) { if (!r.ok) throw data; return data; });
    }).then(function () {
      if (window.FAYQCart) return window.FAYQCart.refresh(true);
      toast(label + ' ' + tr('added'));
      return refreshCount();
    }).catch(function (err) {
      toast((err && err.description) || tr('add_error'), true);
    }).then(function () {
      if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
    });
  }

  /* ---------- Menu mobile ---------- */
  var drawer = $('drawer'), openBtn = $('menuOpen'), closeBtn = $('menuClose');
  function openMenu() { drawer.hidden = false; document.body.style.overflow = 'hidden'; openBtn.setAttribute('aria-expanded', 'true'); closeBtn.focus(); }
  function closeMenu() { drawer.hidden = true; document.body.style.overflow = ''; openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); }
  if (drawer && openBtn && closeBtn) {
    openBtn.addEventListener('click', openMenu);
    closeBtn.addEventListener('click', closeMenu);
    drawer.addEventListener('click', function (e) { if (e.target.closest('nav a')) closeMenu(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) closeMenu(); });
  }

  /* ---------- Packs (accueil + fiche produit) ---------- */
  q('.pack-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var field = form.elements.items;
      var items;
      try { items = JSON.parse(field.value); } catch (err) { toast('Composition invalide.', true); return; }
      addItems(items, form.querySelector('button[type=submit]'), tr('pack') + ' ' + form.getAttribute('data-pack'));
    });
  });

  /* ---------- Fiche produit ---------- */
  var pjson = $('productJson');
  var pform = document.querySelector('.js-ajax-form');
  var pd = document.querySelector('[data-pd]');
  if (pjson && pform) {
    var product = JSON.parse(pjson.textContent);
    var idInput = pform.querySelector('[data-variant-input]');
    var addBtn = pform.querySelector('[data-add-btn]');
    var ctaLabel = pform.querySelector('[data-cta-label]');
    var ctaTotal = pform.querySelector('[data-cta-total]');
    var waLink = document.querySelector('[data-wa-link]');
    var current = product.variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || product.variants[0];

    function flavorVar(name) {
      var n = (name || '').toLowerCase();
      return (n.indexOf('fram') > -1 || n.indexOf('rasp') > -1) ? 'var(--framboise)' : ((n.indexOf('caf') > -1 || n.indexOf('coff') > -1) ? 'var(--cafe)' : 'var(--menthe)');
    }
    function selectedOptions() {
      return q('.pd-flavors', pform).map(function (box) {
        var c = box.querySelector('input:checked');
        return c ? c.value : null;
      }).filter(function (v) { return v !== null; });
    }
    function tierQty() { return +((pform.querySelector('input[name=quantity]:checked') || { value: 1 }).value); }
    function refreshPrices() {
      q('.pd-tier input', pform).forEach(function (inp) {
        var qn = +inp.value, pct = +inp.getAttribute('data-pct') || 0;
        var ref = current.compare_at_price > current.price ? current.compare_at_price : current.price;
        var full = ref * qn, total = Math.round(current.price * qn * (100 - pct) / 100);
        var box = inp.parentNode;
        var t = box.querySelector('[data-tier-total]'); if (t) t.textContent = formatMoney(total);
        var f = box.querySelector('[data-tier-full]'); if (f) f.textContent = formatMoney(full);
        var s = box.querySelector('[data-tier-saved]'); if (s) s.textContent = formatMoney(full - total);
      });
      var checked = pform.querySelector('input[name=quantity]:checked');
      var qn = tierQty(), pct = checked ? (+checked.getAttribute('data-pct') || 0) : 0;
      if (ctaTotal) ctaTotal.textContent = formatMoney(Math.round(current.price * qn * (100 - pct) / 100));
      var pp = document.querySelector('[data-per-pouch]'); if (pp) pp.textContent = formatMoney(Math.round(current.price / 20));
      var pr = document.querySelector('[data-price]'); if (pr) pr.textContent = formatMoney(current.price);
      var hasCmp = current.compare_at_price > current.price;
      var cmp = document.querySelector('[data-compare]');
      if (cmp) { cmp.hidden = !hasCmp; if (hasCmp) cmp.textContent = formatMoney(current.compare_at_price); }
      var off = document.querySelector('[data-off]');
      if (off) { off.hidden = !hasCmp; if (hasCmp) off.textContent = '−' + Math.floor((current.compare_at_price - current.price) * 100 / current.compare_at_price) + ' %'; }
    }
    function showMedia(id, src, alt) {
      var main = $('pdpMain');
      if (main && src) { main.removeAttribute('srcset'); main.src = src; main.alt = alt || ''; }
      q('.pd-thumbs button').forEach(function (b) { b.setAttribute('aria-current', b.getAttribute('data-media-id') === String(id) ? 'true' : 'false'); });
    }
    pform.addEventListener('change', function (e) {
      if (e.target.name === 'quantity') { refreshPrices(); return; }
      if (!e.target.name || e.target.name.indexOf('option-') !== 0) return;
      var opts = selectedOptions();
      var v = product.variants.filter(function (x) { return x.options.join('|') === opts.join('|'); })[0];
      if (!v) return;
      current = v;
      idInput.value = v.id;
      if (pd) pd.style.setProperty('--c', flavorVar(v.title));
      q('[data-flavor-name]').forEach(function (el) { el.textContent = v.title; });
      q('[data-flavor-word]').forEach(function (el) { el.textContent = v.title.toUpperCase(); });
      q('[data-option-label]', pform).forEach(function (l, i) { l.textContent = opts[i]; });
      addBtn.disabled = !v.available;
      if (ctaLabel) ctaLabel.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
      if (waLink) waLink.href = waLink.getAttribute('data-wa-base') + encodeURIComponent('Salam, je veux commander FAYQ ' + v.title);
      refreshPrices();
      if (v.featured_media) {
        var thumb = document.querySelector('.pd-thumbs [data-media-id="' + v.featured_media.id + '"]');
        if (thumb) { showMedia(v.featured_media.id, thumb.getAttribute('data-src'), thumb.getAttribute('data-alt')); thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); }
      }
      var url = new URL(location.href); url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url.toString());
    });
    pform.addEventListener('submit', function (e) {
      e.preventDefault();
      var qty = tierQty();
      addItems([{ id: +idInput.value, quantity: qty }], addBtn, current.title + ' × ' + qty);
    });
    q('.pd-thumbs button').forEach(function (b) {
      b.addEventListener('click', function () { showMedia(b.getAttribute('data-media-id'), b.getAttribute('data-src'), b.getAttribute('data-alt')); });
    });
  }

  /* ---------- Panier ---------- */
  var cartForm = $('cartForm');
  if (cartForm) {
    var submitTimer;
    function scheduleUpdate() { clearTimeout(submitTimer); submitTimer = setTimeout(function () { cartForm.submit(); }, 500); }
    q('[data-qty-step]', cartForm).forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentNode.querySelector('[data-cart-qty]');
        input.value = Math.max(0, (+input.value || 0) + (+b.getAttribute('data-qty-step')));
        scheduleUpdate();
      });
    });
    q('[data-cart-qty]', cartForm).forEach(function (i) { i.addEventListener('change', scheduleUpdate); });
  }

  /* ---------- CTA collant (mobile) ---------- */
  var sticky = $('stickyCta');
  var target = document.getElementById('boutique') || document.getElementById('acheter');
  if (sticky && target && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { sticky.style.visibility = en[0].isIntersecting ? 'hidden' : 'visible'; }, { threshold: 0.1 }).observe(target);
  }
})();

/* ---------- Animations de la maquette (révélations, compteurs, parallaxe) ---------- */
(function () {
  var root = document.documentElement;
  var motion = root.classList.contains('js');
  var q = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var header = document.querySelector('header.site');
  var bar = document.getElementById('progress');

  function tag(sel, type, step) {
    q(sel).forEach(function (el) {
      if (el.hasAttribute('data-reveal')) return;
      el.setAttribute('data-reveal', type || '');
      var sibs = Array.prototype.filter.call(el.parentNode.children, function (s) { return s.matches(sel); });
      el.style.setProperty('--d', (sibs.indexOf(el) * (step || 0.1)) + 's');
    });
  }
  tag('.sec-head h2, .story-copy h2, .brief h2, .brief2 h2, .comp-copy h2, .how h2, .faq h2, .community h2, .page-hero h1', 'rise', 0);
  tag('main .eyebrow', '', 0);
  tag('.sec-head p, .story-copy p, .story-copy .sig, .how .note, .faq .wrap > div > p, .community p', '', 0.1);
  tag('.flavor', '', 0.14);
  tag('.pack', '', 0.14);
  tag('.moment', '', 0.12);
  tag('.stat', '', 0.12);
  tag('.how li', '', 0.14);
  tag('.trust > div', '', 0.1);
  tag('.faq details', '', 0.07);
  tag('.ingr li', '', 0.1);
  tag('.comp-side > *', '', 0.15);
  tag('.comp-copy > p', '', 0);
  tag('.story .word', 'pop', 0);
  tag('.community .btn-wa, .link-arrow', '', 0.15);
  tag('footer.site .grid > div', '', 0.08);
  tag('.stats', 'line', 0);
  tag('.brief .answer, .brief2-answer', '', 0);
  tag('.brief2-tiles .tile', '', .06);
  tag('.facts-list > div', '', 0.05);

  function countUp(el) {
    var b = el.querySelector('b'); if (!b || b.dataset.done) return;
    b.dataset.done = 1;
    var node = b.firstChild; if (!node || node.nodeType !== 3) return;
    var m = node.nodeValue.match(/^(\d+)(.*)$/); if (!m) return;
    var end = +m[1], rest = m[2], t0 = null, dur = 1200;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
      node.nodeValue = Math.round(end * e) + rest;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  var items = q('[data-reveal]');
  if (!motion || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('in');
        if (en.target.classList.contains('stat')) countUp(en.target);
        io.unobserve(en.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
    window.__fayqSweep = function () {
      items = items.filter(function (el) {
        if (el.classList.contains('in')) return false;
        if (el.getBoundingClientRect().top < innerHeight) {
          el.classList.add('in');
          if (el.classList.contains('stat')) countUp(el);
          return false;
        }
        return true;
      });
    };
    setTimeout(window.__fayqSweep, 2500);
  }

  var sun = document.querySelector('.hero-art .sun');
  var stack = document.querySelector('.hero-art .stack');
  var c1 = document.querySelector('.hero-art .c1'), c3 = document.querySelector('.hero-art .c3');
  var ring = document.getElementById('ring');
  var story = document.querySelector('.story');
  var bigs = q('.flavor .top .big');
  var giant = document.querySelector('footer.site .giant');
  var ticking = false;

  function frame() {
    ticking = false;
    var y = scrollY, H = innerHeight;
    var max = document.documentElement.scrollHeight - H;
    if (bar) bar.style.transform = 'scaleX(' + (max > 0 ? y / max : 0) + ')';
    if (header) header.classList.toggle('compact', y > 80);
    if (window.__fayqSweep) window.__fayqSweep();
    if (!motion) return;
    if (sun && y < H * 1.2) {
      sun.style.translate = '0 ' + (y * 0.35) + 'px';
      if (stack) stack.style.translate = '0 ' + (y * -0.08) + 'px';
      if (c1) c1.style.translate = (y * -0.12) + 'px ' + (y * 0.05) + 'px';
      if (c3) c3.style.translate = (y * 0.12) + 'px ' + (y * 0.05) + 'px';
    }
    if (story && ring) {
      var r = story.getBoundingClientRect();
      if (r.bottom > 0 && r.top < H) ring.style.transform = 'rotate(' + ((H - r.top) * 0.15) + 'deg)';
    }
    bigs.forEach(function (b) {
      var br = b.getBoundingClientRect();
      if (br.bottom > 0 && br.top < H) b.style.translate = ((br.top - H / 2) * 0.25) + 'px 0';
    });
    if (giant) {
      var g = giant.getBoundingClientRect();
      if (g.top < H) giant.style.translate = '0 ' + Math.max(0, (g.top - H * 0.5) * 0.3) + 'px';
    }
  }
  addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
  addEventListener('resize', frame);
  frame();
})();

/* ---------- Barre d'annonce : rotation + compteur ---------- */
(function () {
  var I = (window.FAYQ || {}).i18n || {}, tr = function (k) { return I[k] || k; };
  var bar = document.querySelector('[data-announce]');
  if (!bar) return;
  var msgs = Array.prototype.slice.call(bar.querySelectorAll('.announce-msg'));
  var dots = Array.prototype.slice.call(bar.querySelectorAll('.announce-dots i'));
  var endStr = bar.getAttribute('data-end');
  var end = endStr ? new Date(endStr + 'T23:59:59') : null;
  if (end && isNaN(end.getTime())) end = null;
  var cds = Array.prototype.slice.call(bar.querySelectorAll('[data-cd]'));
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    if (!cds.length) return;
    var left = end ? end.getTime() - Date.now() : -1;
    if (left <= 0) {
      // Offre terminée ou pas de date : on retire les messages à compteur
      cds.forEach(function (c) { var m = c.closest('.announce-msg'); if (m && m.parentNode) { var i = msgs.indexOf(m); if (i > -1) { msgs.splice(i, 1); if (dots[i]) { dots[i].remove(); dots.splice(i, 1); } } m.remove(); } });
      cds = [];
      if (msgs.length && !msgs.some(function (m) { return m.classList.contains('is-on'); })) { msgs[0].classList.add('is-on'); msgs[0].removeAttribute('aria-hidden'); if (dots[0]) dots[0].classList.add('on'); }
      return;
    }
    var s = Math.floor(left / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), mn = Math.floor(s % 3600 / 60), sec = s % 60;
    var txt = (d ? d + ' ' + tr('d') + ' ' : '') + pad(h) + ' ' + tr('h') + ' ' + pad(mn) + ' ' + tr('m') + ' ' + pad(sec) + ' ' + tr('s');
    cds.forEach(function (c) { c.textContent = txt; });
  }
  tick(); setInterval(tick, 1000);
  if (msgs.length < 2) return;
  var i = 0, paused = false, speed = +bar.getAttribute('data-speed') || 4000;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function show(n) {
    if (!msgs.length) return;
    var cur = msgs[i % msgs.length];
    if (cur) { cur.classList.remove('is-on'); cur.classList.add('is-out'); cur.setAttribute('aria-hidden', 'true'); setTimeout(function () { cur.classList.remove('is-out'); }, 450); }
    i = n % msgs.length;
    msgs[i].classList.add('is-on'); msgs[i].removeAttribute('aria-hidden');
    dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
  }
  bar.addEventListener('mouseenter', function () { paused = true; });
  bar.addEventListener('mouseleave', function () { paused = false; });
  if (!reduce) setInterval(function () { if (!paused && !document.hidden) show(i + 1); }, speed);
})();

/* ---------- Menu déroulant : clavier et écrans tactiles ---------- */
(function () {
  var hoverable = matchMedia('(hover: hover)').matches;
  Array.prototype.slice.call(document.querySelectorAll('[data-dd]')).forEach(function (dd) {
    var trigger = dd.querySelector('.nav-dd-trigger');
    function set(open) { dd.classList.toggle('open', open); trigger.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    dd.addEventListener('mouseenter', function () { trigger.setAttribute('aria-expanded', 'true'); });
    dd.addEventListener('mouseleave', function () { set(false); });
    trigger.addEventListener('click', function (e) { if (!hoverable && !dd.classList.contains('open')) { e.preventDefault(); set(true); } });
    dd.addEventListener('keydown', function (e) { if (e.key === 'Escape') { set(false); trigger.focus(); } });
    document.addEventListener('click', function (e) { if (!dd.contains(e.target)) set(false); });
  });
})();

/* ---------- Sélecteur de langue ---------- */
(function () {
  var box = document.querySelector('[data-lang]'); if (!box) return;
  var btn = box.querySelector('.lang-btn'), list = box.querySelector('#langList');
  function set(open) { list.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false'); }
  btn.addEventListener('click', function (e) { e.stopPropagation(); set(list.hidden); if (!list.hidden) { var c = list.querySelector('[aria-current]') || list.querySelector('button'); if (c) c.focus(); } });
  document.addEventListener('click', function (e) { if (!box.contains(e.target)) set(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !list.hidden) { set(false); btn.focus(); } });
})();

/* ---------- Espace client ---------- */
(function () {
  var box = document.querySelector('[data-acct]'); if (!box) return;
  var btn = box.querySelector('.acct-btn'), panel = box.querySelector('#acctPanel');
  function set(open) { panel.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false'); }
  btn.addEventListener('click', function (e) { e.stopPropagation(); set(panel.hidden); if (!panel.hidden) { var f = panel.querySelector('a'); if (f) f.focus({ preventScroll: true }); } });
  document.addEventListener('click', function (e) { if (!box.contains(e.target)) set(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { set(false); btn.focus(); } });
})();

/* ---------- Vidéos clients : lecture quand visible, son au clic, carrousel ---------- */
(function () {
  var cards = Array.prototype.slice.call(document.querySelectorAll('[data-ugc]'));
  if (!cards.length) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function vid(c) { return c.querySelector('video'); }
  function setSound(card, on) {
    cards.forEach(function (c) {
      var v = vid(c), b = c.querySelector('.ugc-sound'); if (!v) return;
      var me = c === card && on;
      v.muted = !me; if (b) b.setAttribute('aria-pressed', me ? 'true' : 'false');
      if (me) v.play().catch(function () {});
    });
  }
  cards.forEach(function (c) {
    var v = vid(c); if (!v) return;
    v.muted = true;
    c.addEventListener('click', function () { setSound(c, v.muted); });
  });
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = vid(e.target); if (!v) return;
        if (e.intersectionRatio >= .6) { v.preload = 'auto'; v.play().catch(function () {}); }
        else { v.pause(); if (!v.muted) setSound(null, false); }
      });
    }, { threshold: [0, .6] });
    cards.forEach(function (c) { if (vid(c)) io.observe(c); });
  }
  Array.prototype.slice.call(document.querySelectorAll('.ugc')).forEach(function (sec) {
    var track = sec.querySelector('[data-ugc-track]'), prev = sec.querySelector('[data-ugc-prev]'), next = sec.querySelector('[data-ugc-next]');
    if (!track || !prev || !next) return;
    function step() { var c = track.querySelector('.ugc-card'); return c ? c.getBoundingClientRect().width + 16 : 300; }
    function upd() { prev.disabled = track.scrollLeft < 8; next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8; }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd); upd();
  });
})();

/* ---------- Panier latéral ---------- */
(function () {
  var cfg = window.FAYQ || {}, R = cfg.routes || {}, I = cfg.i18n || {};
  var box = document.querySelector('[data-cart-drawer]'); if (!box) return;
  var panel = box.querySelector('.cd-panel'), lastFocus = null, timerId = null;
  var sectionUrl = function () { return (R.root || '/').replace(/\/$/, '') + '/?section_id=cart-drawer'; };

  function open() {
    if (!box.hidden) return;
    lastFocus = document.activeElement;
    box.hidden = false; document.documentElement.classList.add('cd-lock');
    requestAnimationFrame(function () { box.classList.add('is-open'); });
    panel.focus({ preventScroll: true });
    startTimer();
  }
  function close() {
    box.classList.remove('is-open'); document.documentElement.classList.remove('cd-lock');
    setTimeout(function () { box.hidden = true; }, 320);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }
  function setCount(n) {
    var c = document.getElementById('cartCount'); if (c) { c.textContent = n; c.setAttribute('data-count', n); }
  }
  function refresh(andOpen) {
    return fetch(sectionUrl(), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-inner]'), cur = box.querySelector('[data-cart-inner]');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      var t = box.querySelector('#cdTitle span'); if (t) setCount(+(t.textContent.replace(/\D/g, '')) || 0);
      if (andOpen) open(); else startTimer();
    });
  }
  function post(url, body) {
    box.classList.add('is-busy');
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return refresh(false).then(function () { return cart; }); })
      .finally(function () { box.classList.remove('is-busy'); });
  }
  function codes() { return Array.prototype.map.call(box.querySelectorAll('[data-cart-uncode]'), function (b) { return b.getAttribute('data-cart-uncode'); }); }

  /* Compte à rebours (optionnel, réglage du thème) */
  function startTimer() {
    var el = box.querySelector('[data-cart-timer]'); clearInterval(timerId); if (!el) return;
    var clock = el.querySelector('[data-cart-clock]'), mins = +el.getAttribute('data-minutes') || 10, end;
    try { end = +sessionStorage.getItem('fayqCartEnd'); } catch (e) {}
    if (!end || end < Date.now()) { end = Date.now() + mins * 60000; try { sessionStorage.setItem('fayqCartEnd', end); } catch (e) {} }
    function tick() {
      var s = Math.max(0, Math.round((end - Date.now()) / 1000));
      clock.textContent = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
      if (!s) clearInterval(timerId);
    }
    tick(); timerId = setInterval(tick, 1000);
  }

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-cart-open]');
    if (o) { e.preventDefault(); open(); refresh(false); return; }
    if (e.target.closest('[data-cart-close]')) { close(); return; }
    var ch = e.target.closest('[data-cart-change]');
    if (ch && box.contains(ch)) { post(R.cartChange, { id: ch.getAttribute('data-cart-change'), quantity: +ch.getAttribute('data-qty') }); return; }
    var ad = e.target.closest('[data-cart-add]');
    if (ad && box.contains(ad)) { ad.disabled = true; post(R.cartAdd, { items: [{ id: +ad.getAttribute('data-cart-add'), quantity: 1 }] }); return; }
    var un = e.target.closest('[data-cart-uncode]');
    if (un && box.contains(un)) { var c = un.getAttribute('data-cart-uncode'); post(R.cartUpdate, { discount: codes().filter(function (x) { return x !== c; }).join(',') }); }
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-cart-discount]'); if (!f) return;
    e.preventDefault();
    var code = (f.elements.code.value || '').trim(); if (!code) return;
    var list = codes(); if (list.indexOf(code) < 0) list.push(code);
    post(R.cartUpdate, { discount: list.join(',') }).then(function (cart) {
      var ok = (cart.discount_codes || []).some(function (d) { return d.code.toLowerCase() === code.toLowerCase() && d.applicable; });
      if (!ok) { var inp = box.querySelector('#cdCode'); if (inp) { inp.value = code; inp.setCustomValidity(I.code_error || ''); inp.reportValidity(); setTimeout(function () { inp.setCustomValidity(''); }, 2500); } }
    });
  });
  document.addEventListener('keydown', function (e) {
    if (box.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(panel.querySelectorAll('a[href],button:not([disabled]),input'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  window.FAYQCart = { open: open, close: close, refresh: refresh };
})();

/* ---------- Cœur « ajouter au panier » des cartes de la gamme ---------- */
(function () {
  var R = (window.FAYQ || {}).routes || {};
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add],[data-quick-items]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.classList.contains('is-busy')) return;
    b.classList.add('is-busy', 'is-on');
    fetch(R.cartAdd || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: b.hasAttribute('data-quick-items') ? JSON.parse(b.getAttribute('data-quick-items')) : [{ id: +b.getAttribute('data-quick-add'), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return window.FAYQCart ? window.FAYQCart.refresh(true) : null; })
      .catch(function () { b.classList.remove('is-on'); })
      .then(function () { b.classList.remove('is-busy'); b.classList.add('pop'); setTimeout(function () { b.classList.remove('pop'); }, 500); });
  });
})();

/* ---------- Connexion : repli sur le lien classique si le composant Shopify ne se charge pas ---------- */
(function () {
  var wraps = document.querySelectorAll('[data-login]'); if (!wraps.length) return;
  setTimeout(function () {
    if (window.customElements && customElements.get('shopify-account')) return;
    Array.prototype.forEach.call(wraps, function (w) {
      var c = w.querySelector('shopify-account'), a = w.querySelector('.login-fallback');
      if (c) c.remove(); if (a) a.hidden = false;
    });
  }, 4000);
})();
